import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const STORAGE_KEY = 'calq_session_notice';

/**
 * Eenmalige melding na login wanneer oudere apparaat-sessies zijn beëindigd (pakketlimiet).
 */
export function SessionNoticeBanner() {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      sessionStorage.removeItem(STORAGE_KEY);
      const j = JSON.parse(raw) as { kind?: string; count?: number };
      if (j.kind === 'older_devices' && typeof j.count === 'number' && j.count > 0) {
        setText(
          `Je organisatiepakket staat een beperkt aantal gelijktijdige apparaten per gebruiker toe. ` +
            `Omdat je opnieuw inlogde, ${j.count === 1 ? 'is één eerdere sessie' : `zijn ${j.count} eerdere sessies`} op andere apparaten beëindigd. ` +
            `Daar moet opnieuw worden ingelogd. Zie Account → Inloggen & apparaten of /prijzen voor uitleg.`
        );
      }
    } catch {
      /* ignore */
    }
  }, []);

  if (!text) return null;

  return (
    <div
      className="border-b border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950 dark:border-amber-900/50 dark:bg-amber-950/40 dark:text-amber-50"
      role="status"
    >
      <div className="mx-auto flex max-w-6xl items-start gap-3 sm:px-2">
        <p className="min-w-0 flex-1 leading-relaxed">{text}</p>
        <button
          type="button"
          onClick={() => setText(null)}
          className="shrink-0 rounded-md p-1 text-amber-900 hover:bg-amber-100 dark:text-amber-100 dark:hover:bg-amber-900/40"
          aria-label="Melding sluiten"
        >
          <X className="h-4 w-4" />
        </button>
        <Link
          to="/account#account-sessies"
          className="hidden shrink-0 text-sm font-medium text-primary underline sm:inline"
          onClick={() => setText(null)}
        >
          Naar account
        </Link>
      </div>
    </div>
  );
}
